import {Component, OnDestroy} from '@angular/core';
import {NavigationStart, Router, RouterOutlet} from '@angular/router';
import {filter, Subject, takeUntil} from 'rxjs';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {BusyService} from './services/busy.service';
import {SystemStateService} from './services/system-state.service';
import {SystemStatePanelComponent} from './shared/system-state-panel/system-state-panel.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet,
        CommonModule,
        FormsModule,
        SystemStatePanelComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnDestroy {
  title = 'secureentry-ui';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private busyService: BusyService,
    private systemStateService: SystemStateService,
  ) {
    this.router.events.pipe(
      filter((event): event is NavigationStart => event instanceof NavigationStart),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      // Busy loader + blocking system overlays must not survive route changes
      // (C30-N01: Analytics → Dashboard left server_unavailable / offline active).
      this.busyService.forceIdle();
      this.systemStateService.notifyNavigationStart();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
